import React, { useEffect, useState } from "react";
import { FaCheck, FaExclamationTriangle, FaWindowClose } from "react-icons/fa";
import IAlert from "./IAlert";
import AlertMessageType from "./AlertMessageType";

// manage alerts display
function AlertMessage({
  type,
  message,
  onClose = () => {},
  onCloseDefault = () => {},
}: IAlert) {
  let icon = <FaExclamationTriangle />;
  let cssDiv =
    "flex items-center p-4 mt-4 rounded-lg fixed w-full z-50 bottom-0";
  let cssButton =
    "ms-auto p-0 inline-flex items-center justify-center h-6 w-6 m-1";

  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      internalCloseManager();
    }, 5000);
    return () => clearTimeout(timeoutRef);
  }, []);

  const internalCloseManager = () => {
    onCloseDefault();
    onClose();
  };

  switch (type) {
    case AlertMessageType.SUCCESS:
      icon = <FaCheck />;
      cssDiv += " text-green-800 bg-green-50";
      cssButton += " hover:bg-green-200";
      break;
    case AlertMessageType.INFO:
      icon = <FaCheck />;
      cssDiv += " text-blue-800 bg-blue-50";
      cssButton += " hover:bg-blue-200";
      break;
    case AlertMessageType.WARNING:
      icon = <FaCheck />;
      cssDiv += " text-orange-800 bg-orange-50";
      cssButton += " hover:bg-orange-200";
      break;
    case AlertMessageType.ERROR:
      icon = <FaCheck />;
      cssDiv += " text-red-800 bg-red-50";
      cssButton += " hover:bg-red-200";
      break;
  }
  return (
    <div className={cssDiv}>
      {icon}
      <div className="ml-4">{message}</div>
      <button
        type="button"
        className={cssButton}
        onClick={() => {
          internalCloseManager();
        }}
      >
        <FaWindowClose />
      </button>
    </div>
  );
}

export default AlertMessage;
